import { render, staticRenderFns } from "./SimpleRichEditor.vue?vue&type=template&id=52f8915b&scoped=true"
import script from "./SimpleRichEditor.vue?vue&type=script&lang=js"
export * from "./SimpleRichEditor.vue?vue&type=script&lang=js"
import style0 from "./SimpleRichEditor.vue?vue&type=style&index=0&id=52f8915b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f8915b",
  null
  
)

export default component.exports